<ngx-masonry>
  <div ngxMasonryItem class="masonry-item" *ngFor="let item of pictures">
    {{ item.title }}
  </div>
</ngx-masonry>
